<template>
  <span>
    <point-toolbar :point-info="point.name"/>
    <point-counter-install
      v-if="installing"
      :point-id="point.point_id"
      @cancel="cancelEditing"
      @installed="counterInstalled"
      @installError="editCounterError"
    />

    <counter-edit
      v-if="counterEditing"
      :counter-data="selectedCounterData"
      @cancel="cancelEditing"
      @edited="counterEdited"
      @editError="editCounterError"
    />

    <point-counter-take-off
      v-if="takingOff"
      :counter-data="selectedCounterData"
      @cancel="cancelEditing"
      @edited="counterTakeOff"
      @editError="editCounterError"
    />

    <point-counter-edit-connect-parameters
      v-if="showCounterConnectParameters"
      :counter-data="selectedCounterData"
      @edited="counterConnectEdited"
      @cancel="cancelEditing"
      @editError="editCounterError"
    />

    <v-dialog
      v-model="showCounterHistory"
      width="800px"
    >
      <counter-history
        v-if="showCounterHistory"
        :counter-data="selectedCounterData"
        @close="closeCounterHistory"
      />
    </v-dialog>

    <v-layout
      v-if="loading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>

    <span v-else-if="showList">
      <v-card class="point-counters-card">
        <v-card-title
          v-if="showSuccessMsg"
          class="success-message"
          :class="{ 'success-message-hide': !showSuccess}"
        >
          <div class="headline success-message-text"><i class="far fa-check-circle" /> Счетчик успешно добавлен</div>
        </v-card-title>

        <v-card-title
          v-if="showErrorMsg"
          class="error-message"
          :class="{ 'error-message-hide': !showError}"
        >
          <div class="headline success-message-text"><i class="far fa-times-circle" /> {{ errorMsg }}</div>
        </v-card-title>
        <v-btn
          v-if="!point.counter_id"
          fab
          @click="installCounter"
          color="primary"
          class="install-button"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-data-table
          :headers="headers"
          :items="items"
          fixed-header
          no-data-text="Нет данных для отображения"
          hide-default-footer
          dense
        >
          <tr
            slot="item"
            slot-scope="props"
          >
            <td>{{ props.item.is_current ? 'Установлен' : 'Снят' }}</td>
            <td>
              {{ props.item.serial_num }}
            </td>
            <td>{{ props.item.model_name }}</td>
            <td>{{ props.item.coeff }}</td>
            <td>{{ props.item.coeff_voltage }}</td>
            <td v-if="props.item.last_install_date">
              {{ props.item.last_install_date | moment("DD/MM/YYYY HH:mm:ss") }}
            </td>
            <td v-else />
            <td><span class="action-btns">
              <v-btn
                icon
                title="Параметры подключения"
                :disabled="!props.item.is_current"
                @click="editConnectParameters(props.item)"
              >
                <v-icon color="grey darken-1">mdi-ethernet-cable</v-icon>
              </v-btn>
              <v-btn
                icon
                title="Редактирование счетчика"
                @click="editCounter(props.item)"
              >
                <v-icon color="grey darken-1">edit</v-icon>
              </v-btn>
              <!--history-->
              <v-btn
                icon
                title="История операций по счётчику"
                @click="counterHistory(props.item)"
              >
                <v-icon color="grey darken-1">mdi-history</v-icon>
              </v-btn>
              <!--take counter off-->
              <v-btn
                icon
                title="Снятие счётчика"
                :disabled="!props.item.is_current"
                @click="takeOff(props.item)"
              >
                <v-icon color="grey darken-1">mdi-cancel</v-icon>
              </v-btn>
            </span></td>
          </tr>
        </v-data-table>
      </v-card>
    </span>
  </span>
</template>

<script>
import PointCounterInstall from './PointCounterInstall.vue'
import CounterHistory from '../../counters/CounterHistory.vue'
import CounterEdit from '../../counters/CounterEdit.vue'
import PointCounterTakeOff from './PointCounterTakeOff.vue'
import PointCounterEditConnectParameters from './PointCounterEditConnectParameters.vue'
import PointToolbar from '../PointToolbar'
export default {
  name: 'PointCounters',
  components: {
    PointCounterInstall,
    CounterHistory,
    CounterEdit,
    PointCounterTakeOff,
    PointCounterEditConnectParameters,
    PointToolbar
  },
  data () {
    return {
      pointId: this.$route.params['id'],
      point: {
        'counter_id': 0
      },
      items: [],
      loading: true,
      pointHaveCounter: true,
      headers: [
        {
          text: 'Статус',
          align: 'left',
          sortable: false,
          value: 'is_current'
        },
        {
          text: 'Серийный номер',
          align: 'left',
          sortable: false,
          value: 'serial_num'
        },
        {
          text: 'Модель',
          align: 'left',
          sortable: false,
          value: 'model'
        },
        {
          text: 'Коэф. трансформации тока',
          align: 'left',
          sortable: false,
          value: 'coef'
        },
        {
          text: 'Коэф. трансформации напряжения',
          align: 'left',
          sortable: false,
          value: 'coeff_voltage'
        },
        {
          text: 'Дата установки',
          align: 'left',
          sortable: false,
          value: 'install_date'
        },
        { text: '', sortable: false, value: '' }
      ],
      installing: false,
      showSuccess: false,
      showSuccessMsg: false,
      editing: false,
      showList: true,
      counterEditing: false,
      takingOff: false,
      selectedCounterData: {},
      showErrorMsg: false,
      showError: false,
      errorMsg: null,
      showCounterHistory: false,
      showCounterConnectParameters: false
    }
  },
  watch: {
    editing (val) {
      this.showList = !val
      if (!val) {
        this.counterEditing = this.showCounterConnectParameters = this.takingOff = this.installing = false
      }
    }
  },
  mounted () {
    this.getCountersApi()
  },
  methods: {
    getCountersApi () {
      this.getPointApi()
      this.axios.get(`/api/points/${this.pointId}/counters/`)
        .then((response) => {
          this.items = response.data.results
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getPointApi () {
      this.axios.get(`/api/points/${this.pointId}/`)
        .then((response) => {
          this.point = response.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    showErrorMessage (msg) {
      this.errorMsg = msg
      this.showError = true
      this.showErrorMsg = true
      setTimeout(() => {
        this.showError = false
      }, 4000)
      setTimeout(() => {
        this.showErrorMsg = false
      }, 4350)
    },
    counterInstalled (counterData) {
      const counter = this.items.find(item => item.counter_id === counterData.counter_id)
      if (counter) {
        counter.serial_num = counterData.serial_num
        counter.coeff = counterData.coeff
        counter.coeff_voltage = counterData.coeff_voltage
        counter.is_current = true
        counter.last_install_date = counterData.install_date
      } else {
        this.items.unshift({
          counter_id: counterData.counter_id,
          model_name: counterData.model.name,
          serial_num: counterData.serial_num,
          model_id: counterData.model_id,
          remark: counterData.remark,
          is_active: counterData.is_active,
          coeff: counterData.coeff,
          coeff_voltage: counterData.coeff_voltage,
          is_current: true,
          last_install_date: counterData.install_date,
          last_takeoff_date: ''
        })
      }
      this.point.counter_id = counterData.counter_id
      this.editing = false
    },
    counterEdited (counter) {
      Object.assign(this.selectedCounterData, counter)
      this.editing = false
    },
    counterTakeOff () {
      this.selectedCounterData.is_current = false
      this.point.counter_id = null
      this.editing = false
    },
    counterConnectEdited () {
      this.editing = false
    },
    cancelEditing () {
      this.editing = false
    },
    editCounterError (msg) {
      this.editing = false
      this.showErrorMessage(msg)
    },
    editConnectParameters (item) {
      this.selectedCounterData = item
      this.editing = true
      this.showCounterConnectParameters = true
    },
    installCounter () {
      this.installing = true
      this.editing = true
    },
    editCounter (item) {
      this.selectedCounterData = item
      this.editing = true
      this.counterEditing = true
    },
    takeOff (item) {
      if (item.is_current === false) {
        this.showErrorMessage('Cчётчик не установлен на Точку учёта')
        return
      }
      this.selectedCounterData = item
      this.editing = true
      this.takingOff = true
    },
    counterHistory (item) {
      this.selectedCounterData = item
      this.showCounterHistory = true
    },
    closeCounterHistory () {
      this.showCounterHistory = false
    }
  }
}
</script>

<style lang="scss">
  .v-btn.install-button {
    position: absolute;
    right: 15px;
    z-index: 3;
    top: 45px;
  }
  .success-message {
    text-align: center;
    background-color: #56bb60;
  }
  .success-message-hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  }
  .success-message-text {
    width: 100%;
    color: white;
    font-weight: 600;
  }

  .error-message {
    text-align: center;
    background-color: #f91100;
  }
  .error-message-hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.33s, opacity 0.33s linear;
  }
  .error-message-text {
    width: 100%;
    color: white;
    font-weight: 600;
  }
  .v-btn--floating .v-btn__content {
    height: inherit;
  }
  .v-card.point-counters-card {
    position: unset;
    .v-data-table {
      position: absolute;
      height: calc(100% - 64px);
      right: 0;
      left: 0;
    }
    .v-data-table__wrapper {
      max-height: calc(100% - 59px);
    }
  }
  .action-btns {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/spa/points/counters/PointCounters.vue